import * as React from 'react';
import { classes } from './EventHover.st.css';
import WeeklyPopper from '../../../presentationals/WeeklyPopper';
import WeeklyContext from '../../../../context/weeklyContext';
var EventHover = function (_a) {
    var event = _a.event, ariaLabel = _a.ariaLabel, isMobile = _a.isMobile;
    var onEventExpanded = React.useContext(WeeklyContext).onEventExpanded;
    var _b = React.useState(false), isEventEntered = _b[0], setIsEventEntered = _b[1];
    var _c = React.useState(null), expanded = _c[0], setExpanded = _c[1];
    var handleKeyUp = function (e) {
        if (e.key === 'Enter') {
            setIsEventEntered(true);
            setExpanded(e.target);
        }
    };
    var handleEventClick = function (e) {
        var _a = event.extendedProps, recurrence = _a.recurrence, recurringEventId = _a.recurringEventId, calendarId = _a.calendarId;
        setIsEventEntered(false);
        setExpanded(e.currentTarget);
        //@ts-ignore
        onEventExpanded && onEventExpanded({ recurrence: recurrence, recurringEventId: recurringEventId, calendarId: calendarId });
    };
    var closeExpanded = function () {
        setExpanded(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: handleEventClick, onKeyUp: handleKeyUp, className: classes.EventHoverWrapper, tabIndex: event.extendedProps.tabIndex },
            React.createElement("div", { role: 'button', "aria-label": ariaLabel, className: classes.EventHover })),
        isMobile || (React.createElement(WeeklyPopper, { open: Boolean(expanded), anchorEl: expanded, handleCloseClick: closeExpanded, handleClickAway: closeExpanded, isCloseFocused: isEventEntered, event: event }))));
};
export default EventHover;
//# sourceMappingURL=EventHover.js.map